import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { country as CountryApi } from '@teem/constants/api';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  constructor(
    private httpClient: HttpClient) { }

  public all() {
    return this.httpClient.get(`${CountryApi.endPoint}`)
  }

  public banks() {
    return this.httpClient.get(`${CountryApi.saudi_banks}`)
  }

  public banksByCountry(countryId: string) {
    if (countryId)
      return this.httpClient.get(`${CountryApi.banks}?country_id=${countryId}`)
    else
      return this.httpClient.get(`${CountryApi.banks}?limit=100`)
  }

  public signup() {
    return this.httpClient.get(`${CountryApi.signup}`)
  }
}
